import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import dsBankApi from "service/TichHopBank/dsBankApi";
import { pushNotification } from "utils/notifications";
import { DanhSachBankConst } from "../../../../constants/danhSachTaiSanConst";

export const ThemMoiTaiKhoan = (props) => {
  const dispatch = useDispatch();
  const dataSearch = useSelector((state) => state.dataSearchTaiKhoanBank);
  const initDataAddAndEditnew = {
    Id: 0,
    SoTaiKhoan: "",
    HoVaTen: "",
    CCCD: "",
    MaNganHang: "MBBank",
    IsKhoa: "",
    IsDangKyNhanPushBDSD: "",
    SoDienThoai: "",
  };
  const [bDisable, setDisableButton] = useState(false);
  const [dataAddAndEditNew, setDataAddAndEdit] = useState(
    initDataAddAndEditnew
  );
  const currentForm = useForm();
  const { handleSubmit } = currentForm;

  useEffect(() => {
    if (typeof props.data.Id != "undefined" && props.data.Id > 0) {
      setDataAddAndEdit(props.data);
    }
  }, [props.data.Id]);

  const updateTextValue = (field) => (e) => {
    const data = { ...dataAddAndEditNew };
    data[field] = e.target.value;
    setDataAddAndEdit(data);
  };
  const [dataBankCombo, setDataBankCombo] = useState(DanhSachBankConst.Bank);

  const addOrEdit = () => {
    if (dataAddAndEditNew.SoTaiKhoan === "") {
      pushNotification("Nhập số tài khoản!", "error", "TOP_CENTER", 2000);
      return;
    }
    if (dataAddAndEditNew.HoVaTen === "") {
      pushNotification("Nhập họ và tên!", "error", "TOP_CENTER", 2000);
      return;
    }
    if (dataAddAndEditNew.CCCD === "") {
      pushNotification("Nhập số CCCD!", "error", "TOP_CENTER", 2000);
      return;
    }

    setDisableButton(true);
    dsBankApi.addOrUpdate(dataAddAndEditNew).then((response) => {
      setDisableButton(false);
      if (response.status === 200) {
        props.data.onSearch();
        setDataAddAndEdit(initDataAddAndEditnew);
        props.onHide();
        pushNotification("Thao tác thành công", "success", "TOP_CENTER", 2000);
      } else {
        pushNotification(response, "error", "TOP_CENTER", 2000);
      }
    });
  };

  return (
    <Modal
      {...props}
      backdrop={false}
      size="modal-new-size modal-new-size"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <Modal.Header>
        <h4 className="modal-title  color7-bold" id="myModalLabel16">
          <span className="btn-icon-right">
            <img src="/app-assets/images/icon-them-moi-hop-dong-v2.png" />
          </span>{" "}
          {dataAddAndEditNew.Id > 0 ? "Sửa" : "Thêm mới"} tài khoản ngân hàng
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={props.onHide}
        >
          <img src="/app-assets/images/icon-dong-popup-v2.png" />
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="form-body">
          <div className="card collapse-icon accordion-icon-rotate">
            <div
              id="headingCollapse196"
              className="card-header border-info"
              href="#collapse196"
              aria-expanded="true"
              aria-controls="collapse196"
            >
              <a className="card-title lead info collapsed" href={() => false}>
                <h3>Thông tin</h3>
              </a>
            </div>
            <div
              id="collapse196"
              aria-labelledby="headingCollapse96"
              className="card-collapse collapse show"
              aria-expanded="true"
            >
              <div className="card-content">
                <div className="form-group row">
                  <label className="col-md-2 label-control">
                    Họ và tên <span className="canh-bao-red">*</span>
                  </label>
                  <div className="col-md-4">
                    <input
                      type="text"
                      className="form-control input-sm"
                      value={dataAddAndEditNew.HoVaTen}
                      onChange={updateTextValue("HoVaTen")}
                    />
                  </div>
                  <label className="col-md-2 label-control">
                    CCCD <span className="canh-bao-red">*</span>
                  </label>
                  <div className="col-md-4">
                    <input
                      type="text"
                      className="form-control input-sm"
                      value={dataAddAndEditNew.CCCD}
                      onChange={updateTextValue("CCCD")}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-md-2 label-control">
                    Số tài khoản <span className="canh-bao-red">*</span>
                  </label>
                  <div className="col-md-4">
                    <input
                      type="text"
                      className="form-control input-sm"
                      value={dataAddAndEditNew.SoTaiKhoan}
                      onChange={updateTextValue("SoTaiKhoan")}
                    />
                  </div>
                  <label className="col-md-2 label-control">
                    Số điện thoại <span className="canh-bao-red">*</span>
                  </label>
                  <div className="col-md-4">
                    <input
                      type="text"
                      className="form-control input-sm"
                      value={dataAddAndEditNew.SoDienThoai}
                      onChange={updateTextValue("SoDienThoai")}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-md-2 label-control">
                    Ngân hàng <span className="canh-bao-red">*</span>
                  </label>
                  <div className="col-md-4">
                    <select
                      class="form-control input-sm"
                      value={dataAddAndEditNew.MaNganHang}
                      onChange={updateTextValue("MaNganHang")}
                    >
                      {dataBankCombo &&
                        dataBankCombo.map((item, idx) => (
                          <option key={"comboBank" + idx} value={item.value}>
                            {item.label}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="modal-footer">
        <button
          type="button"
          class="btn btn-new-main btn-closenew"
          href={() => false}
          onClick={props.onHide}
        >
          <span>
            <i class="mdi mdi-close"></i>
          </span>
          &nbsp; Đóng &nbsp;
        </button>
        <button
          className="btn btn-new-main btn-checknew"
          type="submit"
          onClick={addOrEdit}
          disabled={bDisable}
        >
          <span>
            <img src="/app-assets/images/icon-save-v2-white.png" />
          </span>
          &nbsp; {dataAddAndEditNew.Id > 0 ? "Cập nhật" : "Thêm mới"} &nbsp;
        </button>
      </Modal.Footer>
    </Modal>
  );
};
